import React, { Component } from 'react';

import moment from 'moment';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

import SelectClearIcon from '@atlaskit/icon/glyph/select-clear';
import Tooltip from '@atlaskit/tooltip';

import { Label } from '@qality/common-components';
import { DateFormatService } from '@qality/common-service';

import './_date-range-select.scss';

type DateSelectOption = {
  name: string;
  value: string;
};

type Props = {
  onChange: (value: [DateSelectOption, DateSelectOption]) => void;
  isDisabled: boolean;
  tooltip?: string;
  startDate?: string;
  endDate?: string;
};

type State = {
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  displayFormat: string;
  focusedInput: FocusedInputShape;
};

export default class DateRangeSelect extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    let datesState;
    if (props.startDate && props.endDate) {
      datesState = {
        startDate: moment(props.startDate),
        endDate: moment(props.endDate),
      };
    } else if (props.startDate === null && props.endDate === null) {
      datesState = {
        startDate: null,
        endDate: null,
      };
    } else {
      datesState = {
        startDate: moment().subtract(6, 'days'),
        endDate: moment(),
      };
    }

    this.state = {
      ...datesState,
      displayFormat: DateFormatService.dateFormat,
      focusedInput: null,
    };
  }

  onChange = ({
    startDate,
    endDate,
  }: {
    startDate: moment.Moment;
    endDate: moment.Moment;
  }): void => {
    const newDates = {
      startDate: startDate,
      endDate: endDate,
    };

    if (startDate && !endDate) {
      newDates.endDate = moment();
    } else if (!startDate && endDate) {
      newDates.startDate = moment(endDate).subtract(6, 'days');
    }

    this.setState(newDates);
    this.props.onChange([
      {
        name: 'startDate',
        value: moment(newDates.startDate).format('YYYY-MM-DD'),
      },
      {
        name: 'endDate',
        value: moment(newDates.endDate).format('YYYY-MM-DD'),
      },
    ]);
  };

  render(): React.ReactNode {
    const { isDisabled } = this.props;
    const className =
      'hide-focus-wrapper' +
      (isDisabled ? 'date-select-container-disabled' : '');

    return (
      <div className={className}>
        <Label text='Date range' />
        <Tooltip content={this.props.tooltip}>
          <div>
            <DateRangePicker
              disabled={this.props.isDisabled}
              onDatesChange={this.onChange}
              displayFormat={this.state.displayFormat}
              startDate={this.state.startDate}
              endDate={this.state.endDate}
              startDateId='start_date_id'
              endDateId='end_date_id'
              focusedInput={this.state.focusedInput}
              onFocusChange={(focusedInput) => this.setState({ focusedInput })}
              minimumNights={0}
              isOutsideRange={() => false}
              showClearDates
              customCloseIcon={
                <SelectClearIcon
                  label=''
                  size='small'
                  primaryColor='var(--ds-icon-subtle, var(--ds-fb-icon-subtle))'
                />
              }
            />
          </div>
        </Tooltip>
      </div>
    );
  }
}
